import Abonos from './Abonos';

export default Abonos;
